import { View, Text, Image } from 'react-native';
import { Card, Switch } from 'react-native-paper';
import CustomButton from './CustomButton';
import { appColors } from '../global/constant/colors';
import useCart from '../hooks/useCart';
import useProduct from '../hooks/useProduct';
import { useState } from 'react';
import useOrg from '../hooks/useOrg';

interface IProps {
  barcode: string;
  is_single: number;
  price: string;
  product_category_description: string;
  product_category_id: number;
  product_category_name: string;
  product_category_url: null;
  product_description: string;
  product_id: number;
  product_name: string;
  product_name_group: string;
  product_name_group_id: number;
  stock_id: number;
  stock_remaining: number | string;
  stock_value: string;
}

const CustomTillProductCard = ({ data, setSearchQuery }: any) => {
  let val: IProps = data;
  const { getOrgData, org } = useOrg();

  const { addToCart } = useCart();
  const { getAllProductOnLocalDBByKeySearch, toggleQuickItem, isProductInQuickItem, addToQuickItem } = useProduct();
  const [isSwitchOn, setIsSwitchOn] = useState(isProductInQuickItem(data.product_id) ? true : false);

  const onToggleSwitch = () => {
    setIsSwitchOn(!isSwitchOn);
    addToQuickItem(data);
  };
  return (
    <>
      <Card
        style={{ backgroundColor: '#ffffff', height: 150, marginTop: 5, marginBottom: 5, margin: 10, width: '30%' }}
        mode="elevated"
      >
        <View style={{ flex: 1, padding: 16 }}>
          <View style={{ flex: 1, flexDirection: 'column' }}>
            {/* Top section - Product name and switch */}
            <Switch
              style={{ height: 12 }}
              color={isSwitchOn ? 'rgba(37, 135, 47, 1)' : 'rgba(183, 35, 0, 1)'}
              value={isSwitchOn}
              onValueChange={onToggleSwitch}
            />
            <View style={{ height: 65, marginTop: 5 }}>
              <View style={{ marginLeft: 10, flex: 1 }}>
                <Text
                  numberOfLines={4}
                  ellipsizeMode="tail"
                  style={{
                    fontWeight: 'bold',
                    fontSize: 12,
                    color: appColors.primary,
                    textTransform: 'capitalize',
                  }}
                >
                  {val?.product_name}
                  {/* Now the highlighted code (stock information and Add to Cart */}
                </Text>
                <View style={{ flexDirection: 'row' }}>
                  <Text
                    style={{ fontWeight: '600', fontSize: 10, color: appColors.primary, marginTop: 4, marginRight: 2 }}
                  >
                    {org?.country?.currency_symbol}{val.price}
                  </Text>
                  {val?.stock_remaining !== 'Out of Stock' && (
                    <Text
                      style={{
                        fontWeight: '500',
                        fontSize: 10,
                        color: appColors.primary,
                        marginTop: 4,
                        marginBottom: 4,
                      }}
                    >
                      - {val.stock_remaining} {val?.stock_value}
                    </Text>
                  )}
                </View>
              </View>
            </View>

            {/* Bottom section - Stock info and Add to Cart button */}
            <View style={{ alignItems: 'center' }}>
              {val?.stock_remaining == 'Out of Stock' || val?.stock_remaining == 0 ? (
                <Text style={{ fontWeight: 'bold', fontSize: 14, color: 'red' }}>Out of Stock</Text>
              ) : (
                <CustomButton
                  fontSize={12}
                  onPress={() => {
                    addToCart(data), setSearchQuery('');
                  }}
                  bntType="primary"
                  mode="contained-tonal"
                  text="Add to Cart "
                  disable={val?.stock_remaining == 'Out of Stock' ? true : false}
                />
              )}
            </View>
          </View>
        </View>
      </Card>
    </>
  );
};

export default CustomTillProductCard;
